/**
 * api-interceptor.js - Configuración centralizada de fetch para API
 * 
 * Estrategia:
 * - Desarrollo: Intenta localhost:8000 (PHP servidor)
 * - Producción: Usa ruta relativa /api.php
 */

const API_BASE = import.meta.env.DEV ? 'http://localhost:8000' : '';

export async function apiCall(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      credentials: 'include', // Para enviar cookies de sesión
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(error.error || `API Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    throw error;
  }
}

/**
 * Global fetch override - para retro-compatibilidad
 * Intercepta todos los fetch(/api.php) y redirige si es necesario
 */
export function setupGlobalApi() {
  // Always ensure requests to /api.php include credentials by default
  if (!window.__originalFetch) window.__originalFetch = window.fetch;

  window.fetch = function(...args) {
    let [resource, config] = args;
    config = config || {};

    try {
      const urlStr = typeof resource === 'string' ? resource : resource.url;

      if (typeof urlStr === 'string' && urlStr.includes('/api.php')) {
        // Ensure credentials are included for session cookie transport
        config.credentials = config.credentials || 'include';

        if (import.meta.env.DEV && urlStr.startsWith('/api.php')) {
          // In dev try local PHP server first
          const devResource = `http://localhost:8000${resource}`;
          console.log(`[API] DEV proxy -> ${devResource}`);
          return window.__originalFetch(devResource, config).catch(() => {
            console.warn('[API] localhost:8000 not available, falling back to relative path');
            return window.__originalFetch(resource, config);
          });
        }
      }
    } catch (e) {
      // Ignore parsing errors and proceed with original args
    }

    return window.__originalFetch(resource, config);
  };
}
